import React from "react";
import { RecIcon, RecThumb } from "./MaterialRecordParts";
import { formatCost, hasLoadedField, isServiceType } from "./materialRecordModel";

/**
 * Thumbnail-view tile: the image is dominant, the name is clear, and one
 * short line identifies it (cost when visible, otherwise the unit).
 * Same selection semantics as MaterialRow.
 */
export function MaterialTile({
  material,
  canViewPricing,
  selecting = false,
  selected = false,
  onToggle,
  onOpen,
  imageUrl,
}) {
  const cost =
    canViewPricing && hasLoadedField(material, "unit_cost") ? formatCost(material) : null;
  const unit = material.unit_of_measure || "";
  const service = isServiceType(material.material_type);
  const meta = [cost, unit].filter(Boolean).join(" · ") || (service ? "Service" : "");
  const inactive = material.active === false;

  return (
    <button
      type="button"
      className={`mat-tile${selected ? " is-selected" : ""}${inactive ? " is-inactive" : ""}`}
      onClick={() => (selecting ? onToggle?.() : onOpen?.(material))}
      role={selecting ? "checkbox" : undefined}
      aria-checked={selecting ? selected : undefined}
      aria-label={selecting ? `Select ${material.material_name}` : undefined}
    >
      <span className="mat-tile__media">
        <RecThumb
          name={material.material_name}
          type={material.material_type}
          imageUrl={imageUrl}
          size="fill"
        />
        {selecting ? (
          <span className="mat-tile__check" aria-hidden="true">
            <RecIcon name="check" />
          </span>
        ) : null}
      </span>
      <span className="mat-tile__name">{material.material_name}</span>
      {meta ? (
        <span className={`mat-tile__meta${cost === "—" ? " is-none" : ""}`}>{meta}</span>
      ) : null}
    </button>
  );
}
